import HelperLoader from "../../helpers/loader.js";
import Config from "./config.js";

/**
 * Loader — injects the Chili Piper concierge script and resolves once `window.ChiliPiper` exists.
 *
 * Lazy on purpose, exactly like 1Mind's launcher: a page carrying this API pays nothing until
 * someone actually books. Idempotent — the vendor script is fetched once per page.
 */
const Loader = {};

let pending = null;

/** Is the vendor global already up? */
Loader.ready = () => typeof window.ChiliPiper === "object" && window.ChiliPiper !== null;

/**
 * Ensure the vendor script is loaded.
 *
 * @param  {string} account
 * @return {Promise<object>}  resolves with window.ChiliPiper
 */
Loader.load = function (account) {
  if (Loader.ready()) return Promise.resolve(window.ChiliPiper);

  if (pending) return pending;

  pending = HelperLoader.loadScripts([Config.loaderUrl(account)]).then(() => {
    if (!Loader.ready()) {
      throw new Error("[ThryvApi.chiliPiper] concierge.js loaded but window.ChiliPiper is missing");
    }

    return window.ChiliPiper;
  });

  return pending;
};

export default Loader;
